// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import moment from 'moment'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, validPhone, createDefaultVehicle, getWalletScriptUrl } from '../../../constants/globalConstants'
import Header from '../../../components/global/Header'
import YankeeStep from '../../../components/global/YankeeStep'
import Home from '../home'
import SignUp from '../signup'
import Pass from '../pass'
import Driver from '../driver'
import ThankYou from '../thankyou'
import { Circles } from 'react-loader-spinner'
import { encryptionHandler, validateEmail, isPermissionExist, sortPortalPermissionByKey, validatePassword, hasDuplicateAnyKeyValues, isVehicleLimitExceeded, getDeviceType, showhideWalletButton } from '../../../utils/helper'
import { updateWaitingList } from '../../../redux/actions/waitingListActions'
//import { bookPermit ,getPaymentInitials,saveBookingBeforePayment,saveBookingAfterPayment} from '../../../redux/actions/paymentActions'
import { getPaymentInitials, yankeesPurchasePermit } from '../../../redux/actions/paymentActions'

import { permitRateList } from '../../../redux/actions/BasicInfoAction'
import WalletButtons from '../../../components/walletButtons'
import { addScript } from '../../warningCitation/utils/addScript'

function Main(props) {
    // const facilityState = localStorage.getItem('facility') && localStorage.getItem('facility')!='undefined' ? JSON.parse(localStorage.getItem('facility')) : {}
    const { dispatch, isAuthenticated, partnerDetails, notify } = props
    let defaultCountry = partnerDetails?.facilities?.[0]?.country_code ? partnerDetails?.facilities?.[0]?.country_code : 'US'
    const defaultFormData = {
        vehicleList: [createDefaultVehicle(defaultCountry, true)],
        userConsent: false,
        permitNegotiate: 0,
        country: defaultCountry,
        userAcknowledge: true, request_reason: ''
    }
    const [page, setPage] = useState()
    const [active, setActive] = useState('home')
    const [idProof, setIdProof] = useState(EMPTY_OBJECT)
    const [formData, setFormData] = useState(defaultFormData)
    const [vehicleListArray, setVehicleListArray] = useState(EMPTY_ARRAY)
    const [formError, setFormError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [previousActive, setPreviousActive] = useState(false)
    const [response, setResponse] = useState(EMPTY_OBJECT)
    const [paymentResponse, setPaymentResponse] = useState(false)
    const [paymentStatus, setPaymentStatus] = useState(EMPTY_OBJECT)
    const [VehiclePrev, setVehiclePrev] = useState(true)
    const [vehicleCount, setvehicleCount] = useState(0)
    const [errorMessage, setErrorMessage] = useState()
    const [res, setRes] = useState('')
    // const [url, setUrl] = useState('')
    const [guid, setGuid] = useState(EMPTY_OBJECT)
    const promotion = window.location.toString().split('/')[4]
    const [accessPermissions, setAccessPermissions] = useState('')
    const [mainVehicleMakeList, setMainVehicleMakeList] = useState(EMPTY_ARRAY)
    const [selectedVehicleList, setSelectedVehicleList] = useState(EMPTY_ARRAY)

    const [isIOSDevice, setIsIOSdevice] = useState(false)
    const [verifyPrepay, setVerifyPrepay] = useState('1')
    const [walletDisable, setWalletDisable] = useState(false)

    const loaded = useRef()
    const applePaySessionRef = useRef(null)
    const [walletButtonShow, setWalletButtonShow] = useState(null)


    // Load Wallet Payment Script
    useEffect(() => {
        // Load Wallet Payment Script
        if(formData?.selFaclity && (formData?.selFaclity?.facility_configuration?.show_google_pay_button == '1' || formData?.selFaclity?.facility_configuration?.show_apple_pay_button == '1')) {
            const paymentGateway = formData?.selFaclity?.facility_payment_details?.facility_payment_type_id
            const applePayScript = getWalletScriptUrl(paymentGateway)
            Object.values(applePayScript)?.map((item) => {
                if(item){
                    addScript(loaded, item, '')
                }
            })
            const getWalletPermission = isPermissionExist(accessPermissions, 'Enable A/G Pay - Permit')
            setWalletButtonShow(showhideWalletButton(formData?.selFaclity) && getWalletPermission)
        }
        // Load Wallet Payment Script
    },[EMPTY_ARRAY, formData?.selFaclity])

    //const navigate = useNavigate()
    const formRef = useRef()
    useEffect(() => {
        if (page == 'thankyou') {
            setActive('thankyou')
        }
        if (page == 'pass') {
            paymentInitials(formData)
        }
    }, [page])

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
        const deviceType = getDeviceType()
        setIsIOSdevice(deviceType)
    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        if (isAuthenticated) {
            setIsLoggedIn(true)
        } else {
            const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
            if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token != '') {
                setIsLoggedIn(true)
            } else {
                setIsLoggedIn(false)
            }
        }


    }, [EMPTY_ARRAY, isAuthenticated, page])

    const getVals = () => {
        return formData
    }
    
    const closeApplePaySession = (endsession) => {
        if (applePaySessionRef.current) {
            if(endsession === 'success') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            } else if (endsession === 'failed') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
            } else {
                applePaySessionRef.current.abort()
            }
        }
    }

    const paymentInitials = (formData) => {
        const paymentSessionPayload = {
            'permit_rate_id': formData?.permit_rate_id,
            'license_number': formData?.license_number,
            'facility_id': formData?.facility_id,
            'promocode': '',
        }
        dispatch(getPaymentInitials(paymentSessionPayload)).then((response) => {
            // setUrl(response?.data?.api_url)
            setRes(response?.data?.ipgSession)
            setGuid(response?.data?.guid)
            localStorage.setItem('paymentSession', JSON.stringify(response?.data))
        }).catch((err) => {
            notify('error', err ? err : 'Something went wrong, Please try again!')
            setIsLoading(false)
        })
    }


    const checkPermitUsage = () => {
        const permitPayload = {
            'facility_id': formData?.facility_id,
            'is_promotion': promotion && promotion != '' && promotion == 'permittype2' ? '1' : '0',
            'driving_license': formData?.license_number || '',
        }
        dispatch(permitRateList(permitPayload)).then((res) => {

            const selectedPermit = res?.data?.filter((item) => item?.id == formData?.permit_type)
            // const permit = selectedPermit?.data[0]
            const permitRates = selectedPermit?.[0]?.permit_rate
            const selectedPermitRates = permitRates?.filter((item) => item?.id == formData?.permit_rate_id)

            const selectedPermitRate = selectedPermitRates?.[0]
            if (selectedPermitRate?.remaining_usage == 0) {
                localStorage.removeItem('paymentSession')
                const userData = JSON.parse(localStorage.getItem('userData'))
                const payload = {
                    facility_id: formData?.facility_id,
                    partner_id: partnerDetails?.id,
                    name: `${formData?.firstname ? formData?.firstname : ''} ${formData?.lastname ? formData?.lastname : ''}`,
                    email: formData?.email ? formData?.email : '',
                    phone: formData?.phone ? formData?.phone : '',
                    license_number: formData?.license_number ? formData?.license_number : '',
                    first_name: formData?.firstname ? formData?.firstname : '',
                    confirm_password: formData?.cpassword,
                    password: formData?.password,
                    last_name: formData?.lastname ? formData?.lastname : '',
                    user_id: isLoggedIn ? userData?.user?.id : '',
                    address1: formData?.address1 ? formData?.address1 : '',
                    address2: formData?.address2 ? formData?.address2 : '',
                    city: formData?.city ? formData?.city : '',
                    state: formData?.state ? formData?.state : '',
                    zipcode: formData?.zipcode ? formData?.zipcode : '',
                    permit_rate: formData?.permit_rate ? formData?.permit_rate : '',
                    permit_rate_id: formData?.permit_rate_id ? formData?.permit_rate_id : '',
                    desired_start_date: moment().format('YYYY/MM/DD'),
                    month: 1,
                    type_id: 3
                }
                dispatch(updateWaitingList(payload)).then((res) => {
                    localStorage.removeItem('paymentSession')
                    if (res?.data) {
                        const userData = res?.data?.userDetails
                        if (userData?.access_token && userData?.access_token != '') {
                            localStorage.setItem('userData', JSON.stringify(userData))
                        } else {
                            const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                            if (userDetailsFromLocal) {
                                userDetailsFromLocal.user = userData
                                localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                            }

                        }
                    }
                    setIsLoading(false)
                    setResponse(response)
                    setPaymentStatus(false)
                    setActive('thankyou')
                    setResponse(res?.data?.message ? res?.data?.message : 'Maximum passes have been sold for this permit, You are added in the waiting list, and will be notified when a pass is available.')
                    if (res?.data?.message == 'Invalid password.') {
                        setPreviousActive(true)
                    } else {
                        setPreviousActive(false)
                    }
                }).catch((err) => {
                    localStorage.removeItem('paymentSession')
                    const response = err?.errors
                    setResponse(response?.message ? response?.message : 'Something went wrong, Please try again!')
                    if (response?.message == 'Invalid password.') {
                        setPreviousActive(true)
                    } else {
                        setPreviousActive(false)
                    }
                    setIsLoading(false)
                    setResponse(response)
                    setPaymentStatus(false)
                    setActive('thankyou')
                })
            } else {
                setIsLoading(false)
                setErrorMessage('')
                setActive('driver')
            }
        }).catch((err) => {
            localStorage.removeItem('paymentSession')
            const response = err?.errors
            setResponse(response?.message ? response?.message : 'Something went wrong, Please try again!')
            if (response?.message == 'Invalid password.') {
                setPreviousActive(true)
            } else {
                setPreviousActive(false)
            }
            setIsLoading(false)
            setActive('thankyou')
        })
    }
    const handleNext = (event, prepay = '') => {
        // const licenseCheck = !isPermissionExist(accessPermissions, 'Driving License')
        if (page == 'home') {
            setFormError('home')
            setErrorMessage('')
            if (Object.values(formData).length > 0 && formData?.facility_id && formData?.permit_type != '' && formData?.permit_rate != '') {

                if (formData?.permit_rate == '' || formData?.permit_rate == undefined || formData?.permit_rate == null) {
                    setErrorMessage('')
                } else {

                    const payloadData = { ...formData }
                    payloadData['vehicleList'] = vehicleListArray
                    setFormData({ ...payloadData })
                    setErrorMessage('')
                    setActive('signup')
                    // setVehiclePrev(false)

                    // const vehicles = vehicleListArray
                    // const emptyLicenseVehicle = vehicles?.filter((item) => item?.license_plate == '')
                    // if (emptyLicenseVehicle?.length > 0) {
                    //     // setErrorMessage('Please add a vehicle')
                    // } 
                    // // else if(idProof?.front == undefined || idProof?.back == undefined){
                    // //     // no message
                    // // }
                    // else {
                    //     const payloadData = {...formData}
                    //     payloadData['vehicleList'] = vehicleListArray
                    //     setFormData({ ...payloadData })
                    //     setErrorMessage('')
                    //     setActive('signup')
                    //     setVehiclePrev(false)
                    // }

                }

            } else {
                // Need to check this statement
            }
        } else if (page == 'signup') {
            // paymentInitials(formData)
            setFormError('signup')
            setIsLoading(true)
            setErrorMessage('')

            if (Object.values(formData).length > 0 && formData?.firstname && formData?.email && formData?.address1 && formData?.city && formData?.state && formData?.zipcode) {
                if (isLoggedIn) {
                    if (formData?.email) {
                        if (validateEmail(formData?.email)) {
                            if ((!formData?.phone || (formData?.phone && validPhone.test(formData?.phone) && formData?.phone?.length == 10))) {
                                checkPermitUsage()
                            } else {
                                setIsLoading(false)
                            }
                        } else {
                            setIsLoading(false)
                        }
                    }
                } else {
                    if (formData?.email) {
                        if (validateEmail(formData?.email)) {
                            setErrorMessage('')
                            if (formData?.password) {
                                if (formData?.password == formData?.cpassword) {
                                    if (validatePassword(formData?.password)) {
                                        if ((!formData?.phone || (formData?.phone && validPhone.test(formData?.phone) && formData?.phone?.length == 10))) {
                                            checkPermitUsage()
                                        } else {
                                            setIsLoading(false)
                                        }
                                    } else {
                                        setIsLoading(false)
                                    }

                                } else {
                                    setIsLoading(false)
                                }
                            } else {
                                setIsLoading(false)
                            }

                        } else {
                            setIsLoading(false)
                        }
                    }
                }
            } else {
                setIsLoading(false)
            }

        } else if (page == 'driver') {
            const maxAllowed = partnerDetails?.max_vehicle
            const limitExceeded = isVehicleLimitExceeded(accessPermissions, selectedVehicleList?.length, maxAllowed, false)
            if (Object.values(formData).length > 0 && formData?.facility_id && (selectedVehicleList?.length > 0 && !limitExceeded) && formData?.driver) {
                let newlyAddedVehicle = selectedVehicleList?.filter(item => !item?.id)
                let totalVehiclesList = [...newlyAddedVehicle, ...vehicleListArray]
                const emptyLicenseVehicle = totalVehiclesList?.filter((item) => item?.license_plate == '' || item?.license_plate.length < 1)
                let driverLists = formData?.driver
                const emptyDriver = driverLists?.filter((item) => item?.driver_name == '')
                const emptyVehicleType = totalVehiclesList?.filter((item) => item?.vehicle_type == '')
                if (emptyLicenseVehicle?.length > 0) {
                    // setErrorMessage('Please add a vehicle')
                    setFormError('driver')
                } else if (emptyDriver?.length > 0) {
                    // setErrorMessage('Please add a vehicle')
                    setFormError('driver')
                } else if ((isPermissionExist(accessPermissions, 'Get Vehicle Type') && emptyVehicleType.length > 0)) {
                    // setErrorMessage('Please add a vehicle type')
                } else {
                    let newPyalod = []
                    let checkMakeModel = false
                    let licenseDuplicateCheck = hasDuplicateAnyKeyValues(totalVehiclesList, ['license_plate'])
                    selectedVehicleList.map((item) => {
                        const make = item?.make_id ? '' : (item?.othermake ? (item?.maketext || '') : (item?.make || ''))
                        const model = item?.model_id ? '' : (item?.othermodel ? (item?.modeltext || '') : (item?.model || ''))
                        newPyalod.push({ 'license_plate': item?.license_plate, 'make': make, 'make_id': item?.make_id ? item?.make_id : '', 'model': model, 'model_id': item?.model_id ? item?.model_id : '', 'color': item?.color_id ? '' : item?.color, 'color_id': item?.color_id ? item?.color_id : '', 'country': item?.country ? item.country : '', 'state_id': item?.state_id, 'vehicle_number': item?.vehicle_number, 'vehicle_type': item?.vehicle_type, 'vehicle_type_id': item?.vehicle_type_id ?? '' })

                        //check
                        if (checkMakeModel == false && item?.make == 'Others') {
                            checkMakeModel = mainVehicleMakeList?.some((value) => value?.name?.toLowerCase() == item?.maketext?.toLowerCase())
                            if (checkMakeModel) {
                                notify('error', `You can not add duplicate ${licenseDuplicateCheck ? 'License Plate and' : ''} Make.`)
                            }
                        } else if (checkMakeModel == false && item?.make != 'Others' && item?.model == 'Others') {
                            let makeList = mainVehicleMakeList?.filter((v) => v.name.toLowerCase() == item?.make.toLowerCase())
                            checkMakeModel = makeList[0]?.mst_model?.some((value) => value?.name?.toLowerCase() == item?.modeltext?.toLowerCase())
                            if (checkMakeModel) {
                                notify('error', `You can not add duplicate ${licenseDuplicateCheck ? 'License Plate and' : ''} Model.`)
                            }
                        }
                    })
                    if (!checkMakeModel) {
                        if (licenseDuplicateCheck) {
                            notify('error', 'You can not add duplicate License Plate.')
                        } else {
                            const payloadData = { ...formData }
                            payloadData['vehicleList'] = selectedVehicleList
                            setFormData({ ...payloadData })
                            setErrorMessage('')
                            if(prepay == 'post' && walletButtonShow) {
                                handleSubmit(event, prepay)
                            } else {
                                setActive('pass')
                                setVehiclePrev(false)
                            }
                        }
                    }
                }

            } else {
                if (selectedVehicleList?.length == 0) {
                    notify('error', 'You have to add at least one vehicle.')
                } else if (limitExceeded) {
                    notify('error', `You can not add more than ${maxAllowed} vehicles.`)
                }
                setFormError('driver')
            }

        } else if (page == 'pass') {

            paymentInitials(formData)
            setErrorMessage('')
            setActive('thankyou')
        }
    }
    const handlePrevious = () => {
        setVerifyPrepay('1')
        if (page == 'signup') {
            setErrorMessage('')
            setActive('home')
        } else if (page == 'pass') {
            setErrorMessage('')
            setActive('driver')
        } else if (page == 'driver') {
            setErrorMessage('')
            setActive('signup')
        } else if (page == 'thankyou') {
            if(walletButtonShow) {
                setActive('driver')
            } else {
                setActive('pass')
            }
            setErrorMessage('')
        }
    }

    const handleSubmit = (data, prepay = '') => {
        // const event = e
        // const form = formRef.current
        if(prepay != 'post' || !walletButtonShow) {
            setFormError('pass')
        }
        // paymentInitials(formData)
        // if (Object.values(formData).length > 0 && ((formData?.card_pan && formData?.name && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code))) {
        if (!isLoading) {

            // if (Object.values(formData).length > 0 && (formData?.payment_profile_id || (formData?.card_pan && formData?.name && formData?.card_date_expiry_month && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code)) || formData?.permit_rate == '0.00') {
            // if (Object.values(formData).length > 0 && (formData?.payment_profile_id || (formData?.card_pan && formData?.name && formData?.expiration_date && (formData?.expiration_date?.length>3 && formData?.expiration_date?.length<6) && formData?.card_card_security_cvx_2 && formData?.zip_code)) || formData?.permit_rate == '0.00') {
            if ((Object.values(formData).length > 0 && (prepay == 'post' || data?.walletPay || formData?.payment_profile_id || (formData?.card_pan && formData?.name && formData?.expiration_date && (formData?.expiration_date?.length > 3 && formData?.expiration_date?.length < 6) && formData?.card_card_security_cvx_2 && formData?.zip_code))
                || (formData?.permit_rate == '0.00')) && (!isPermissionExist(accessPermissions, 'Display Terms & Conditions') || (isPermissionExist(accessPermissions, 'Display Terms & Conditions') && formData?.userAcknowledge))) {


                setErrorMessage('')
                setIsLoading(true)
                const userData = JSON.parse(localStorage.getItem('userData'))
                const paymentSessionValue = JSON.parse(localStorage.getItem('paymentSession'))
                let nonce
                // if (!formData?.payment_profile_id && (formData?.payment_profile_id == '' || formData?.payment_profile_id == undefined || formData?.payment_profile_id == null)
                //         && (formData?.name && formData?.card_pan && formData?.card_date_expiry_month && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code)
                //     ) {

                // const card_expiration_date = formData?.card_date_expiry_month + formData?.card_date_expiry_year
                if (!formData?.payment_profile_id && (formData?.payment_profile_id == '' || formData?.payment_profile_id == undefined || formData?.payment_profile_id == null)
                    && (formData?.name && formData?.card_pan && formData?.expiration_date && formData?.card_card_security_cvx_2 && formData?.zip_code)
                ) {
                    const card_expiration_date = formData?.expiration_date
                    let cardData = {
                        name_on_card: formData?.name,
                        card_number: formData?.card_pan ? formData?.card_pan.replace(/\D/g, '') : '',
                        expiration_date: card_expiration_date ? card_expiration_date.replace(/\D/g, '') : '',
                        security_code: formData?.card_card_security_cvx_2,
                        zip_code: formData?.zip_code
                    }
                    nonce = encryptionHandler(cardData)
                }

                let finalVehicleList = []
                selectedVehicleList?.map((value) => {
                    if (value?.license_plate) {
                        finalVehicleList.push({ 'license_plate': value?.license_plate, 'make': value?.make_id ? '' : (value?.othermake ? value?.maketext : value?.make), 'make_id': value?.make_id ? value?.make_id : '', 'model': value?.model_id ? '' : (value?.othermodel ? value?.modeltext : value?.model), 'model_id': value?.model_id ? value?.model_id : '', 'color': value?.color, 'color_id': value?.color_id ? value?.color_id : '', 'state_id': value?.state_id, 'state_name': '', 'country': value?.country ? value?.country : '', 'vehicle_type': value?.vehicle_type, 'vehicle_type_id': value?.vehicle_type_id ?? '' })
                    }
                })
                let formPostData = new FormData()    //formdata object
                //let driverName=[]
                let driverListData = formData?.driver

                const desiredStartDate = props?.data?.proRateList?.data?.start_date || (formData?.desired_start_date ? moment(formData.desired_start_date).format('YYYY/MM/DD') : null) || moment().format('YYYY/MM/DD')

                for (let i = 0; i < driverListData?.length; i++) {
                    // driverName.push(driverList[i]?.driver_name)
                    formPostData.append(`driver_signature${i}`, driverListData[i]?.driver_signature)
                }
                formPostData.append('license_number', formData?.license_number ? formData?.license_number : '')   //append the values with key, value pair
                formPostData.append('first_name', formData?.firstname ? formData?.firstname : '')
                formPostData.append('email', formData?.email ? formData?.email : '')
                formPostData.append('phone', formData?.phone ? formData?.phone : '')
                formPostData.append('vehicleList', JSON.stringify(finalVehicleList))
                formPostData.append('confirm_password', formData?.cpassword ? formData?.cpassword : '')
                formPostData.append('password', formData?.password ? formData?.password : '')
                formPostData.append('facility_id', formData?.facility_id ? formData?.facility_id : '')
                formPostData.append('last_name', formData?.lastname ? formData?.lastname : '')
                formPostData.append('user_id', isLoggedIn ? userData?.user?.id : '')
                formPostData.append('address1', formData?.address1 ? formData?.address1 : '')
                formPostData.append('address2', formData?.address2 ? formData?.address2 : '')
                formPostData.append('city', formData?.city ? formData?.city : '')
                formPostData.append('state', formData?.state ? formData?.state : '')
                formPostData.append('country', formData?.country ? formData?.country : '')
                formPostData.append('company_name', formData?.company_name ? formData?.company_name : '')
                formPostData.append('zipcode', formData?.zipcode ? formData?.zipcode : '')
                formPostData.append('name', formData?.name ? formData?.name : '')
                formPostData.append('permit_rate', formData?.permit_rate ? formData?.permit_rate : '')
                formPostData.append('permit_rate_id', formData?.permit_rate_id ? formData?.permit_rate_id : '')
                formPostData.append('desired_start_date', desiredStartDate)
                formPostData.append('month', 1)
                formPostData.append('user_consent', formData?.userConsent ? formData?.userConsent == true ? 1 : 0 : 0)
                formPostData.append('image_front', idProof?.front ? idProof?.front : '')
                formPostData.append('is_card_req', 1)
                formPostData.append('image_back', idProof?.back ? idProof?.back : '')
                formPostData.append('type_id', 3)
                formPostData.append('payment_profile_id', formData?.payment_profile_id ? formData?.payment_profile_id : '')
                formPostData.append('promocode', formData?.coupon_applied == true ? formData?.promocode ? formData?.promocode : '' : '')
                formPostData.append('reference', paymentSessionValue?.reference ? paymentSessionValue.reference : '')
                formPostData.append('is_admin', 0)
                formPostData.append('permit_type_name', formData?.permit_type_name ? formData?.permit_type_name : '')
                formPostData.append('driver', formData?.driver ? JSON.stringify(formData?.driver) : [])
                formPostData.append('is_payment_authrize', '1')
                formPostData.append('processing_fee', formData?.processing_fee ? formData?.processing_fee : '')
                if(walletButtonShow) {
                    formPostData.append('verify_prepay', (prepay && prepay == 'post') ? '1' : '0')
                }
                if(data?.walletPay) {
                    if(isIOSDevice) {
                        formPostData.append('walletPay', JSON.stringify(data?.walletPay))
                    } else {
                        formPostData.append('walletPay', data?.walletPay)
                    }
                    formPostData.append('paymentMethods', data?.paymentMethods)
                } else {
                    formPostData.append('nonce', nonce ? nonce : '')
                }


                if (formData?.permit_rate == '0.00' || Number(formData?.permit_rate) == 0) {
                    formPostData.append('is_booking_direct', 1)
                }
                //USM
                if (formData?.permitService) {
                    formPostData.append('permitService', JSON.stringify(formData?.permitService))
                }
                if (formData?.permit_category) {
                    formPostData.append('permit_category', formData?.permit_category)
                }
                if (formData?.user_type_id) {
                    formPostData.append('user_type_id', formData?.user_type_id)
                }
                if (formData?.user_remark) {
                    formPostData.append('user_remark', formData?.user_remark)
                }

                localStorage.setItem('bookingType', 'Permit')


                // dispatch(saveBookingBeforePayment(beforePaymentPayload)).then((response) => {
                dispatch(yankeesPurchasePermit(formPostData)).then((response) => {
                    if(prepay && prepay == 'post' && response?.data) {
                        setVerifyPrepay('0')
                        setIsLoading(false)
                        setActive('pass')
                        setVehiclePrev(false)
                    } else {
                        const responseData = response?.data
                        // localStorage.setItem('responseData-before-api', JSON.stringify(responseData))               
                        if (responseData) {
                            setIsLoading(false)
                            setPaymentResponse(responseData)
                            setPaymentStatus(true)
                            setPreviousActive(false)
                            const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                            if (userDetailsFromLocal?.access_token) {
                                closeApplePaySession('success')
                                if (responseData?.error_msg && responseData?.error_msg != '') {
                                    setResponse(responseData?.error_msg)
                                    setPaymentStatus(false)
                                    const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                    userDetailsFromLocal.user = responseData?.userDetails
                                    // const userData = responseData?.userDetails
                                    if (userDetailsFromLocal) {
                                        localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                    } else {
                                        localStorage.setItem('userData', '{}')
                                    }
                                    setPage('thankyou')

                                } else {
                                    const userData = responseData?.userDetails
                                    if (userData) {
                                        const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                        userDetailsFromLocal.user = userData
                                        localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                    } else {
                                        localStorage.setItem('userData', '{}')
                                    }
                                    setResponse(response)
                                    setPage('thankyou')
                                    
                                }
                            } else {
                                closeApplePaySession('failed')
                                if (responseData?.error_msg && responseData?.error_msg != '') {
                                    setResponse(responseData?.error_msg)
                                    setPaymentStatus(false)
                                    const userData = responseData?.userDetails
                                    if (userData) {
                                        localStorage.setItem('userData', JSON.stringify(userData))
                                    } else {
                                        localStorage.setItem('userData', '{}')
                                    }
                                    setPage('thankyou')
                                } else {

                                    const userData = responseData?.userDetails

                                    if (userData) {

                                        localStorage.setItem('userData', JSON.stringify(userData))

                                    } else {
                                        localStorage.setItem('userData', '{}')
                                    }
                                    setPage('thankyou')
                                    setResponse(response)
                                }
                            }
                        } else {
                            setIsLoading(false)
                            closeApplePaySession('failed')
                            const errors = response?.errors
                            setResponse(errors ? errors?.message : 'Something went wrong, Please try again!')
                            //old                  
                            if (errors?.message == 'Invalid password.' || !response?.message || response?.message == '' || response?.message == undefined || response?.message == null) {
                                setPreviousActive(true)
                            } else {
                                setPreviousActive(false)
                            }
                            setIsLoading(false)
                            setPaymentStatus(false)
                            setPage('thankyou')
                        }
                        // formRef.current = false
                    }
                }).catch((err) => {
                    closeApplePaySession('failed')
                    setResponse(err ? err : 'Something went wrong, Please try again!')
                    //old                  
                    setIsLoading(false)
                    setPage('thankyou')
                })
                // .catch((error) => { 
                //     formRef.current = false
                //     const ErrorMsg = error?.errors                   
                //     setResponse(ErrorMsg?.message ? ErrorMsg?.message : error)               
                //     setPage('thankyou')
                // })                       

            } else {
                setIsLoading(false)
            }

        }
    }


    return (
        <div>
            {/* loggedInError={loggedInError} */}
            <Header page={page} partnerDetails={partnerDetails} />
            <main>

                <section id="forms" className="formDesign ">
                    <div className="container mt-2 " id="qbox-container">
                        <div className='row justify-content-center'>
                            <div className="col-md-10 text-center mb-3">
                                <h1 className='h2 mb-0'>Monthly Parking Registration</h1>
                            </div>
                        </div>
                    </div>
                    <YankeeStep
                        page={page}
                    />
                    <div className="container mt-2 " id="qbox-container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                {/* <form className="needs-validation" id="form-wrapper" method="post" action={url} name="form-wrapper"
                                    noValidate=""> */}
                                <form ref={formRef} id='ipg_form' target="_top" name='ipg_form' method='post' onSubmit={() => handleSubmit()}>
                                    <div id="steps-container">
                                        {active == 'home' && <Home setPage={setPage} setIdProof={setIdProof} vehicleCount={vehicleCount} setvehicleCount={setvehicleCount} idProof={idProof} VehiclePrev={VehiclePrev} vehicleListArray={vehicleListArray} setVehicleListArray={setVehicleListArray} formData={formData} setFormData={setFormData} formError={formError} partnerDetails={partnerDetails} />}
                                        {active == 'signup' && <SignUp setPage={setPage} isLoggedIn={isLoggedIn} formData={formData} setFormData={setFormData} formError={formError} partnerDetails={partnerDetails} />}
                                        {active == 'driver' && <Driver
                                            notify={notify} setPage={setPage}
                                            setIdProof={setIdProof} vehicleCount={vehicleCount}
                                            setvehicleCount={setvehicleCount} idProof={idProof}
                                            VehiclePrev={VehiclePrev} vehicleListArray={vehicleListArray}
                                            setVehicleListArray={setVehicleListArray}
                                            formData={formData} setFormData={setFormData}
                                            formError={formError} setFormError={setFormError}
                                            partnerDetails={partnerDetails} setMainVehicleMakeList={setMainVehicleMakeList}
                                            selectedVehicleList={selectedVehicleList}
                                            setSelectedVehicleList={setSelectedVehicleList}
                                            verifyPrepay={verifyPrepay} walletButtonShow={walletButtonShow}
                                            setWalletDisable={setWalletDisable}
                                        />}
                                        {active == 'pass' && <Pass guidValue={guid} resValue={res} setPage={setPage} idProof={idProof} notify={notify} formData={formData} setFormData={setFormData} formError={formError} selectedVehicleList={selectedVehicleList} />}
                                        {active == 'thankyou' && <ThankYou setPage={setPage} response={response} paymentStatus={paymentStatus} paymentResponse={paymentResponse} isLoading={isLoading} partnerDetails={partnerDetails} notify={notify} />}
                                    </div>
                                    {errorMessage != '' ? <span className='text-danger'>{errorMessage}</span> : ''}

                                    <div id="q-box__buttons" className="text-center mt-4 d-flex justify-content-center">
                                        {(active != 'home' && (previousActive || active == 'signup' || active == 'driver' || active == 'pass')) &&
                                            <button id="next-btn" type="button" className="btn btn-primary step-btn" onClick={(e) => handlePrevious(e)} disabled={isLoading}>Previous</button>}
                                        &nbsp;
                                        {(active != 'pass' && active != 'thankyou' && !(active == 'driver' && verifyPrepay == '1' && walletButtonShow)) &&
                                            <button id="next-btn" type="button" className="btn btn-primary d-flex step-btn" onClick={(e) => handleNext(e)} disabled={isLoading}>Next {page == 'signup' && isLoading ? <span className=' ms-2'><Circles
                                                height="20"
                                                width="20"
                                                color="#ffffff"
                                                ariaLabel="circles-loading"
                                                visible={true}
                                            /></span> : null}
                                            </button>}&nbsp;
                                        {(active == 'pass') &&
                                            <button id="next-btn" type="button" className="btn btn-primary d-flex step-btn" onClick={(e) => handleSubmit(e)} disabled={isLoading}>Submit {isLoading ? <span className=' ms-2'><Circles
                                                height="20"
                                                width="20"
                                                color="#ffffff"
                                                ariaLabel="circles-loading"
                                                visible={true}
                                            /></span> : null}</button>}
                                        {(active == 'driver' && verifyPrepay == '1' && walletButtonShow) && <button type="button" disabled={isLoading} className="btn btn-primary d-flex step-btn w-auto" onClick={(e) => handleNext(e, 'post')} >
                                            Proceed to Pay
                                        </button>}
                                    </div>
                                </form>
                                {(Number(formData?.permit_rate) > 0 && active == 'pass' && verifyPrepay == '0' && walletButtonShow && (!formData?.proRateAPIData?.error_permit_exist || formData?.proRateAPIData?.error_permit_exist == '')) ? <>
                                    <div className="my-3 fw-bold text-center">- OR -</div>
                                    
                                    <div className='d-flex justify-content-center'>
                                        <div className='position-relative'>
                                            { (walletDisable || isLoading) ? <div className='overlay-opacity'>&nbsp;</div> : null }
                                            <WalletButtons faciltyData={formData?.selFaclity} getValues={getVals} onSubmit={handleSubmit} isSubmittingForm={isLoading} setIsSubmittingForm={setIsLoading} setIsLoading={setIsLoading} payableAmount={formData?.permit_rate} notify={notify} isIOSDevice={isIOSDevice} applePaySessionRef={applePaySessionRef} />
                                        </div>
                                    </div>
                                    <small className='border border-danger p-2 rounded-3 text-center text-small text-danger small w-100'>By using Apple pay/Gpay, the permit can not be auto renewed.</small>
                                </> : ''}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )

}

Main.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    events: PropTypes.object,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    isModeOpen: PropTypes.bool,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
}

Main.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    events: EMPTY_OBJECT,
    loader: false,
    getCard: noop,
    passData: EMPTY_ARRAY,
    isAuthenticated: false,
    isModeOpen: false,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,

}

function mapStateToProps({ paymentReducer, login }) {
    return {
        data: paymentReducer,
        isAuthenticated: login?.isAuthenticated,
    }
}
export default connect(mapStateToProps)(Main)
